import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { LocalStorage } from 'ngx-store';
import { HttpClient } from '@angular/common/http';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { User } from '../login/user.model';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/toPromise';
import { ConsoleService } from '@ng-select/ng-select/ng-select/console.service';

@Injectable({
	providedIn: 'root'
})
export class AuthService {
	@LocalStorage('logged') logged: boolean = false;
	@LocalStorage('usuario') usuario = null;
	private data = null;
	private url = environment.serviceApi;

	constructor(public http: HttpClient,
				public router: Router) { }

	check(): boolean{
		return localStorage.getItem('user') ? true : false;
	}


	login(credentials: {login: string, password: string }): Observable<string> {

		return this.http.post<any>( this.url + '/auth/login', credentials)
			.do(data => {

				localStorage.setItem('token', data.token);
				localStorage.setItem('user',btoa(JSON.stringify(data.user)));

			});

	}

	/*loginOld(login, senha) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/usuarios/login', {
				login: login,
				senha: senha,
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}*/

	loggedIn(usuario) {
		this.logged = true;
		this.usuario = usuario;
	}

	getUsuarioId() {
		if (this.logged)
			return this.getUser().usuario_id; //return this.usuario.usuario_id;
		return null;
	}

	getPerfil() {
		if (this.logged)
		return this.getUser().usuario_perfil; //return this.usuario.usuario_perfil;
		return null;
	}

	logout(): void {
		
		//console.log("[logout]");
		this.http.get(this.url + '/auth/logout').subscribe(resp => {
			//console.log(resp);
			localStorage.clear();
			this.router.navigate(['login']);
		});		
		
		//this.logged = false;
		//this.usuario = null;
		//this.router.navigate(['login']);
	}

	getUser(){
		return localStorage.getItem('user') ? JSON.parse(atob(localStorage.getItem('user'))) : null;
	}

	/*setUser(): Promise<boolean> {
		return this.http.get<any>(this.url + '/auth/users').toPromise()
		.then(data => {
			if(data.user){
				localStorage.getItem('user', btoa(JSON.stringify(data.user)));
				return true;
			}
			return false;
		});

	}*/





} 
